import { Account } from 'common/models';
import http from 'core/services/api';

class AccountRepository {
  getAccount = async () =>
    http.fetch((axios, signal) => axios.get<Account>('/account', { signal }));
}

export const accountRepository = new AccountRepository();
